<template>
  <span class="letter-avatar" :style="badgeStyle">{{ letter }}</span>
</template>

<script>
// Local replacement for `vue-letter-avatar` (Vue 2 only). Takes the first
// character of `name` and renders it on a coloured circle/square.

function hashStringToHue(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash) % 360
}

export default {
  name: 'LetterAvatar',
  props: {
    name: { type: String, default: '' },
    size: { type: [Number, String], default: 35 },
    rounded: { type: Boolean, default: true },
    color: { type: String, default: '#ffffff' },
    backgroundColor: { type: String, default: '' },
  },
  computed: {
    letter() {
      return (this.name || '').trim().charAt(0).toUpperCase()
    },
    badgeStyle() {
      const size = `${this.size}px`
      const bg = this.backgroundColor || `hsl(${hashStringToHue(this.name)}, 60%, 50%)`
      return {
        width: size,
        height: size,
        lineHeight: size,
        fontSize: `${Math.max(10, Number(this.size) / 2)}px`,
        backgroundColor: bg,
        color: this.color,
        borderRadius: this.rounded ? '50%' : '4px',
      }
    },
  },
}
</script>

<style scoped>
.letter-avatar {
  display: inline-block;
  text-align: center;
  font-weight: 600;
  vertical-align: middle;
  user-select: none;
}
</style>
